module.exports = __webpack_public_path__ + "img/IMG_9321_FoamcoreMatted.1b3d6afa.jpg";